import { useEffect } from 'react';

export const useScrollIntoViewIframe = (condition = true) => {
  useEffect(() => {
    if (condition) {
      document.body.scrollIntoView(true);
      window.parent.postMessage(
        {
          code: 'SCROLL_TO_TOP',
        },
        '*',
      );
    }
  }, [condition]);
  return;
};
